import { Dialog, DialogContent, Grid } from '@mui/material';
import RevCodesComponent from './RevCodesComponent';
import { Typography } from '@uhc-tempo/components';

const revCodesStyles = {
    dialogTitle: {
        fontFamily: 'Arial',
        fontSize: '25px',
        color: '#5A5A5A',
    },
    dialogContent: {
        fontFamily: 'sans-serif',
        lineHeight: '1.5',
        color: '#5A5A5A',
        paddingTop: '16px',
        paddingBottom: '16px',
    },
    closeButton: {
        margin: '10px',
    },
    temp: {
        paddingTop: '16px',
        paddingRight: '24px',
        paddingLeft: '24px',
    },
    divider: {
        margin: '0px 24px',
    },
};

export default function RevCodesDialog(props) {
    const { onServiceSelect, displayPopup, onClose } = props;

    return (
        <Dialog
            open={displayPopup}
            onClose={onClose}
            data-testid="revcodes-popup"
            maxWidth={'lg'}
            fullWidth={true}
            id="revcodes-dialog"
            PaperProps={{
                tabIndex: -1,
                id: 'revCodesDialogChildDiv',
                style: { overflowY: 'hidden' },
                'aria-labelledby': 'revCodesH2',
            }}
        >
            <Grid item xs={12}>
                <div id="revenueCodeHeader">
                    <Grid item xs={12}>
                        <Typography.H2 id="revCodesH2" style={revCodesStyles.temp}>
                            {'Refine Your Search'}
                        </Typography.H2>
                    </Grid>
                </div>
                <Grid
                    item
                    xs={12}
                    style={{
                        paddingTop: '16px',
                        paddingRight: '24px',
                        paddingLeft: '24px',
                    }}
                >
                    <Typography.Paragraph data-testid="revCodesDisclaimer">
                        <b>More information is needed to provide an estimate.</b> Based on your
                        search, this list includes the most commonly billed procedure codes. But we
                        can't show a cost estimate without more information. The item you searched
                        for may be part of a larger procedure. You can refine your search in the
                        filter bar.
                    </Typography.Paragraph>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <button
                    className="tds-modal__close"
                    aria-label="close disclaimers"
                    onClick={onClose}
                    style={{ float: 'right' }}
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        role="presentation"
                        className="tds-modal__close--icon"
                    >
                        <title>Close modal</title>
                        <defs>
                            <rect
                                id="modal_000_close"
                                x="0"
                                y="0"
                                width="14"
                                height="14"
                                rx="8"
                            ></rect>
                        </defs>
                        <g fill="none" fillRule="evenodd">
                            <path
                                d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
                                fill="#196ECF"
                            ></path>
                        </g>
                    </svg>
                </button>
            </Grid>

            <DialogContent dividers={scroll === 'paper'} style={revCodesStyles.dialogContent}>
                <RevCodesComponent onServiceSelect={onServiceSelect} onClose={onClose} />
            </DialogContent>
        </Dialog>
    );
}
